export enum ClwNamRequestStatus {
    SAVED = 'saved',
    SUBMITTED = 'submitted',
    PENDING_CUSTOMER_ACTION = 'pending-customer-action',
    REFERRED_OUT = 'referred-out',
    UNDER_REVIEW = 'under-review',
    CLOSED = 'closed'
}

export const statusToDisplayName = new Map<ClwNamRequestStatus, string>([
    [ClwNamRequestStatus.SAVED, 'saved'],
    [ClwNamRequestStatus.SUBMITTED, 'submitted'],
    [ClwNamRequestStatus.PENDING_CUSTOMER_ACTION, 'pending requestor response'],
    [ClwNamRequestStatus.REFERRED_OUT, 'referred out'],
    [ClwNamRequestStatus.UNDER_REVIEW, 'under review'],
    [ClwNamRequestStatus.CLOSED, 'closed']
]);
